export const commonInitialState = {
    data: [],
    isLoading: false,
    error: null,
};
